import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';

const ACCESS_TOKEN_COOKIE = 'digitChatAuthToken';
const USER_DATA_COOKIE = 'digitChatUser';

interface JWTPayload {
  userIdRaw?: string;
  userId?: string;
  projectId?: string;
  exp?: number;
  iat?: number;
}

interface AuthIdentityJWTPayload {
  userIdRaw?: unknown;
  userId?: unknown;
}

const normalizeTokenUserId = (value: unknown): string | null => {
  if (typeof value === 'string' && value.trim()) {
    return value;
  }

  if (typeof value === 'number') {
    return String(value);
  }

  return null;
};

export const getCanonicalAuthUserIdFromToken = (
  token: string | null | undefined
): string | null => {
  if (!token) {
    return null;
  }

  try {
    const decoded = jwtDecode<AuthIdentityJWTPayload>(token);

    return normalizeTokenUserId(decoded.userIdRaw) || normalizeTokenUserId(decoded.userId);
  } catch (_error) {
    return null;
  }
};

export const extractDigitUidFromToken = (): string | null => {
  try {
    const token = (Cookies.get(ACCESS_TOKEN_COOKIE) as string) || '';
    if (!token) return null;

    const decoded = jwtDecode<JWTPayload>(token);
    return decoded.userIdRaw || null;
  } catch (e) {
    return null;
  }
};

export const extractDigitUidFromUserCookie = (): string | null => {
  try {
    const cookieData = Cookies.get(USER_DATA_COOKIE);
    if (!cookieData) return null;

    const userData = JSON.parse(cookieData);
    return userData?.id ? String(userData.id) : null;
  } catch (e) {
    return null;
  }
};

export const extractInternalIdFromUserCookie = (): string | null => {
  try {
    const cookieData = Cookies.get(USER_DATA_COOKIE);
    if (!cookieData) return null;

    const userData = JSON.parse(cookieData);
    return userData?.internalId ? String(userData.internalId) : null;
  } catch (e) {
    return null;
  }
};

export const extractDigitUid = (
  context?: Record<string, unknown>
): { digitUid: string | null; error: string | null } => {
  try {
    let digitUid = extractDigitUidFromToken();

    if (!digitUid) {
      digitUid = extractDigitUidFromUserCookie();
    }

    if (!digitUid && context?.user) {
      digitUid = String(context.user);
    }

    return { digitUid, error: null };
  } catch (e) {
    return {
      digitUid: null,
      error: `Failed to extract digit-uid: ${e instanceof Error ? e.message : String(e)}`
    };
  }
};
